module.exports = __webpack_public_path__ + "38ded8d5021de9317330f2a8cf2020fa.svg";